import configs from './config';

const { OKTA_DOMAIN, OKTA_CLIENT_ID } = configs;

const CLIENT_ID = OKTA_CLIENT_ID;
const ISSUER = `${OKTA_DOMAIN}/oauth2/default`;
const OKTA_TESTING_DISABLEHTTPSCHECK = true;
const REDIRECT_URI = `${window.location.origin}/login/callback`;

export default {
  oidc: {
    clientId: CLIENT_ID,
    issuer: ISSUER,
    redirectUri: REDIRECT_URI,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
  },
  resourceServer: {
    messagesUrl: 'http://localhost:8000/api/messages',
  },
  baseUrl: OKTA_DOMAIN,
  useClassicEngine: true,
};
